// src/components/FilterBar.js
import React from 'react';
import { FunnelIcon, MagnifyingGlassIcon } from '@heroicons/react/24/outline';

const FilterBar = ({ filters, onFilterChange }) => {
  const filterOptions = {
    estado: [
      { value: 'ALL', label: 'Todos los estados' },
      { value: 'Pendiente', label: 'Pendiente' },
      { value: 'Finalizado', label: 'Finalizado' },
      { value: 'Cancelado', label: 'Cancelado' }
    ]
  };

  return (
    <div className="bg-white rounded-lg shadow p-4 mb-6 mt-4">
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        
        <div className="md:col-span-1">
          <label className="block text-sm font-medium text-gray-700 mb-1">Estado</label>
          <div className="relative">
            <select
              value={filters.estado}
              onChange={(e) => onFilterChange('estado', e.target.value)}
              className="w-full pl-3 pr-10 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
            >
              {filterOptions.estado.map(option => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="md:col-span-1">
          <label className="block text-sm font-medium text-gray-700 mb-1">N° Ticket</label>
          <div className="relative">
            <input
              type="text"
              value={filters.numTicket}
              onChange={(e) => onFilterChange('numTicket', e.target.value)}
              className="block w-full pl-3 pr-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
              placeholder="Buscar por número de ticket..."
            />
          </div>
        </div>

        <div className="md:col-span-1">
          <label className="block text-sm font-medium text-gray-700 mb-1">N° Interno Equipo</label>
          <div className="relative">
            <input
              type="text"
              value={filters.codigoEquipo}
              onChange={(e) => onFilterChange('codigoEquipo', e.target.value)}
              className="block w-full pl-3 pr-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
              placeholder="Buscar por número intenro de equipo..."
            />
          </div>
        </div>
        
    {/*     <div className="md:col-span-2">
          <label className="block text-sm font-medium text-gray-700 mb-1">Buscar</label>
          <div className="relative rounded-md shadow-sm">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <MagnifyingGlassIcon className="h-5 w-5 text-gray-400" />
            </div>
            <input
              type="text"
              value={filters.search}
              onChange={(e) => onFilterChange('search', e.target.value)}
              className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
              placeholder="Buscar requerimientos..."
            />
          </div>
        </div>
          */}
        </div>
  
      <div className="mt-4 flex items-center text-sm text-gray-500">
        <FunnelIcon className="h-4 w-4 mr-1" />
        <span>{filters.length} requerimientos encontrados</span>
      </div>
    </div>
  );
};

export default FilterBar;